// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/Users/zhangyongguang/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import SyncOutlined from '/Users/zhangyongguang/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/SyncOutlined';
import CloudUploadOutlined from '/Users/zhangyongguang/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/CloudUploadOutlined';
import SettingOutlined from '/Users/zhangyongguang/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/SettingOutlined';
import CodeOutlined from '/Users/zhangyongguang/workspace/github/sync-ui/node_modules/@ant-design/icons/es/icons/CodeOutlined';
export default { DashboardOutlined, SyncOutlined, CloudUploadOutlined, SettingOutlined, CodeOutlined };
